<div class="layout-menu-profile">
  <button class="p-link" (click)="toggleMenu()" pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled">
    <i class="pi pi-user" style="font-size: 2rem; margin-right:1rem;"></i>
    <!--<img src="assets/demo/images/avatar/amyelsner.png" alt="avatar" style="width: 32px; height: 32px;">-->
    <ng-container *ngIf="kcUserProfile">
      <span>
        <strong>{{kcUserProfile.firstName}} {{kcUserProfile.lastName}}</strong>
        <small>{{kcUserProfile.username}}</small>
      </span>
    </ng-container>
    <i class="layout-menu-profile-toggler pi pi-fw" [ngClass]="{'pi-angle-down': menuProfilePosition === 'start' || isHorizontal, 'pi-angle-up': menuProfilePosition === 'end' && !isHorizontal}"></i>
  </button>

  <ul *ngIf="menuProfileActive" [@menu]="isHorizontal ? 'overlay' : 'inline'">
    <ng-container *ngIf="kcUserProfile">
      <li pTooltip="Установки" [tooltipDisabled]="isTooltipDisabled">
        <button class="p-link" [routerLink]="['/setup']">
          <i class="pi pi-cog pi-fw"></i>
          <span>Установки</span>
        </button>
      </li>
      <ng-container *ngIf="canSeeAgentSetupMenuLink">

        <li pTooltip="Налаштування агента" [tooltipDisabled]="isTooltipDisabled">
          <button class="p-link" [routerLink]="['/agent-setup']">
            <i class="pi pi-android pi-fw"></i>
            <span>Налаштування агента</span>
          </button>
        </li>
      </ng-container>
      <ng-container *ngIf="canSeeEditAccessMenuLink">

        <li pTooltip="Группы доступа" [tooltipDisabled]="isTooltipDisabled">
          <button class="p-link" [routerLink]="['/edit-access']">
            <i class="pi pi-file-o pi-fw"></i>
            <span>Группы доступа</span>
          </button>
        </li>
      </ng-container>
      <ng-container *ngIf="canSeeHiddenDocumentsMenuLink">

        <li pTooltip="Hidden documents" [tooltipDisabled]="isTooltipDisabled">
          <button class="p-link" [routerLink]="['/hidden-documents']">
            <i class="pi pi-eye-slash pi-fw"></i>
            <span>Hidden documents</span>
          </button>
        </li>
      </ng-container>
      <ng-container *ngIf="canSeeEditVariableMenuLink">

        <li pTooltip="Ценовые переменные" [tooltipDisabled]="isTooltipDisabled">
          <button class="p-link" [routerLink]="['/edit-variable']">
            <i class="pi pi-hashtag pi-fw"></i>
            <span>Ценовые переменные</span>
          </button>
        </li>
      </ng-container>
      <li pTooltip="Очистить все индивидуальные настройки" [tooltipDisabled]="isTooltipDisabled">
        <button class="p-link" (click)="clearAppLocalStorage()">
          <i class="pi pi-eraser pi-fw"></i>
          <span>Очистить настройки</span>
        </button>
      </li>
    </ng-container>

    <li pTooltip="Logout" [tooltipDisabled]="isTooltipDisabled">
      <button class="p-link" (click)="auth.logout()">
        <i class="pi pi-sign-out pi-fw"></i>
        <span>Logout</span>
      </button>
    </li>

    <li pTooltip="Logout and Reset" [tooltipDisabled]="isTooltipDisabled">
      <button class="p-link" (click)="logoutAndReset()">
        <i class="pi pi-power-off pi-fw"></i>
        <span>Logout and Reset</span>
      </button>
    </li>
  </ul>
  <ng-template #loggedOut>
    <button mat-icon-button form="" (click)="auth.login()">
      <mat-icon>login</mat-icon>
    </button>
  </ng-template>
</div>
